export default __webpack_public_path__ + "static/Estate-Cleanout-39260983c93c6e89f6ccbf7918936d05.jpg";